<div class="center-header-info">
    <div class="location-column">
        <h3>Global</h3>
        <h4 *ngIf="selectedLocation">{{ selectedLocation?.name | titlecase }}</h4>
    </div>
    <div class="search-column" *ngIf="selectedLocation">
        <emm-menu-search
            (clearSearchButtonClicked)="handleClearSearchButtonClicked()"
            (searchButtonClicked)="handleSearchButtonClicked()"
        ></emm-menu-search>
    </div>
    <div class="button-column">
        <aside class="row">
            <button
                [attr.data-testid]="'add_button'"
                mat-icon-button
                matTooltip="Add Global Submenu"
                (click)="add.emit()"
            >
                <mat-icon class="mat-class">add</mat-icon>
            </button>
            <button
                [attr.data-testid]="'sort_button'"
                mat-icon-button
                matTooltip="Sort Submenus"
                (click)="openMenu($event)"
                *ngIf="!(isSearchMode$ | async)"
            >
                <mat-icon class="mat-class" [matMenuTriggerFor]="sortMenu">sort</mat-icon>
            </button>
            <mat-menu class="sort-menu" #sortMenu="matMenu">
                <ng-template matMenuContent *ngIf="!(isSearchMode$ | async)">
                    <button mat-menu-item (click)="sortByName.emit()">Sort By Name</button>
                    <button mat-menu-item (click)="sortByTag.emit()">Sort By Tag</button>
                </ng-template>
            </mat-menu>
        </aside>
    </div>
</div>
